enum ApprovalStatusEnum {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
}

export default ApprovalStatusEnum;
